// Words every learner screen shares: the verbs on buttons, the states a lesson
// or a piece of homework can be in, the names of things, and what the shared
// components in lib/ say themselves. A screen imports this beside its own
// namespace; a word only one screen uses belongs in that screen's namespace.

import { defineMessages, plural } from './index'

export default defineMessages(
  {
    // ------------------------------------------------------------ actions --
    save: 'Saqlash',
    saving: 'Saqlanmoqda…',
    saved: 'Saqlandi',
    cancel: 'Bekor qilish',
    close: 'Yopish',
    back: 'Orqaga',
    next: 'Keyingi',
    previous: 'Oldingi',
    continue: 'Davom etish',
    start: 'Boshlash',
    search: 'Qidirish',
    loading: 'Yuklanmoqda…',
    retry: 'Qayta urinish',
    refresh: 'Yangilash',
    yes: 'Ha',
    no: 'Yo‘q',
    all: 'Hammasi',
    none: 'Hech biri',
    download: 'Yuklab olish',
    upload: 'Yuklash',
    uploading: 'Yuklanmoqda…',
    uploadingPercent: 'Yuklanmoqda… {percent}%',
    add: 'Qo‘shish',
    remove: 'Olib tashlash',
    edit: 'Tahrirlash',
    delete: 'O‘chirish',
    send: 'Yuborish',
    sending: 'Yuborilmoqda…',
    submit: 'Topshirish',
    done: 'Tayyor',
    open: 'Ochish',
    view: 'Ko‘rish',
    show: 'Ko‘rsatish',
    hide: 'Yashirish',
    more: 'Yana',
    change: 'O‘zgartirish',
    confirm: 'Tasdiqlash',
    copy: 'Nusxalash',
    copied: 'Nusxalandi',

    // ------------------------------------------------------------- states --
    completed: 'Tugatilgan',
    inProgress: 'Jarayonda',
    notStarted: 'Boshlanmagan',
    locked: 'Yopiq',
    pending: 'Tekshirilmoqda',
    accepted: 'Qabul qilingan',
    graded: 'Baholangan',
    rejected: 'Qaytarilgan',
    required: 'Majburiy',
    optional: 'Ixtiyoriy',

    // ------------------------------------------------------------- things --
    course: 'Kurs',
    courses: 'Kurslar',
    module: 'Bo‘lim',
    modules: 'Bo‘limlar',
    lesson: 'Dars',
    lessons: 'Darslar',
    homework: 'Uy vazifasi',
    video: 'Video',
    file: 'Fayl',
    files: 'Fayllar',
    image: 'Rasm',
    points: 'Ballar',
    progress: 'O‘zlashtirish',
    grade: 'Baho',
    comment: 'Izoh',
    date: 'Sana',
    phone: 'Telefon',
    name: 'Ism',
    fullName: 'Ism-familiya',
    username: 'Login',
    password: 'Parol',
    email: 'Elektron pochta',
    lessonsCount: '{n} ta dars',
    lessonsDone: '{done} / {total} dars tugatilgan',
    pointsCount: '{n} ball',

    // ------------------------------------------------------ empty, errors --
    emptyTitle: 'Hozircha hech narsa yo‘q',
    noResults: 'Hech narsa topilmadi',
    loadFailed: 'Yuklab bo‘lmadi',
    unnamed: 'Nomsiz',
    notSet: 'Ko‘rsatilmagan',
    durationHm: '{h} soat {m} daq.',

    // -------------------------------------------------------------- files --
    dropHint: 'Faylni shu yerga tashlang yoki tanlash uchun bosing',
    dropHintMany: 'Fayllarni shu yerga tashlang yoki tanlash uchun bosing',
    dropRelease: 'Qo‘shish uchun qo‘yib yuboring',
    wrongType: '«{name}» — bu turdagi fayl bu yerda qabul qilinmaydi.',

    // -------------------------------------------------------------- phone --
    phoneNumber: 'Telefon raqami',
    phoneCountry: 'O‘zbekiston, +998',
    phoneIncomplete: 'Raqamni to‘liq kiriting: 9 ta raqam.',
  },
  {
    en: {
      save: 'Save',
      saving: 'Saving…',
      saved: 'Saved',
      cancel: 'Cancel',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      continue: 'Continue',
      start: 'Start',
      search: 'Search',
      loading: 'Loading…',
      retry: 'Try again',
      refresh: 'Refresh',
      yes: 'Yes',
      no: 'No',
      all: 'All',
      none: 'None',
      download: 'Download',
      upload: 'Upload',
      uploading: 'Uploading…',
      uploadingPercent: 'Uploading… {percent}%',
      add: 'Add',
      remove: 'Remove',
      edit: 'Edit',
      delete: 'Delete',
      send: 'Send',
      sending: 'Sending…',
      submit: 'Hand in',
      done: 'Done',
      open: 'Open',
      view: 'View',
      show: 'Show',
      hide: 'Hide',
      more: 'More',
      change: 'Change',
      confirm: 'Confirm',
      copy: 'Copy',
      copied: 'Copied',

      completed: 'Completed',
      inProgress: 'In progress',
      notStarted: 'Not started',
      locked: 'Locked',
      pending: 'Awaiting review',
      accepted: 'Accepted',
      graded: 'Graded',
      rejected: 'Returned',
      required: 'Required',
      optional: 'Optional',

      course: 'Course',
      courses: 'Courses',
      module: 'Module',
      modules: 'Modules',
      lesson: 'Lesson',
      lessons: 'Lessons',
      homework: 'Homework',
      video: 'Video',
      file: 'File',
      files: 'Files',
      image: 'Image',
      points: 'Points',
      progress: 'Progress',
      grade: 'Grade',
      comment: 'Comment',
      date: 'Date',
      phone: 'Phone',
      name: 'Name',
      fullName: 'Full name',
      username: 'Username',
      password: 'Password',
      email: 'Email',
      lessonsCount: (v, lang) => plural(lang, Number(v.n), { one: '{n} lesson', other: '{n} lessons' }),
      lessonsDone: '{done} of {total} lessons completed',
      pointsCount: (v, lang) => plural(lang, Number(v.n), { one: '{n} point', other: '{n} points' }),

      emptyTitle: 'Nothing here yet',
      noResults: 'Nothing found',
      loadFailed: 'Couldn’t load',
      unnamed: 'Unnamed',
      notSet: 'Not set',
      durationHm: '{h} h {m} min',

      dropHint: 'Drop a file here or click to choose one',
      dropHintMany: 'Drop files here or click to choose',
      dropRelease: 'Release to add',
      wrongType: '“{name}” is not a file type accepted here.',

      phoneNumber: 'Phone number',
      phoneCountry: 'Uzbekistan, +998',
      phoneIncomplete: 'Enter the full number: 9 digits.',
    },
    ru: {
      save: 'Сохранить',
      saving: 'Сохранение…',
      saved: 'Сохранено',
      cancel: 'Отмена',
      close: 'Закрыть',
      back: 'Назад',
      next: 'Далее',
      previous: 'Назад',
      continue: 'Продолжить',
      start: 'Начать',
      search: 'Поиск',
      loading: 'Загрузка…',
      retry: 'Повторить',
      refresh: 'Обновить',
      yes: 'Да',
      no: 'Нет',
      all: 'Все',
      none: 'Ни одного',
      download: 'Скачать',
      upload: 'Загрузить',
      uploading: 'Загрузка…',
      uploadingPercent: 'Загрузка… {percent}%',
      add: 'Добавить',
      remove: 'Убрать',
      edit: 'Изменить',
      delete: 'Удалить',
      send: 'Отправить',
      sending: 'Отправка…',
      submit: 'Сдать',
      done: 'Готово',
      open: 'Открыть',
      view: 'Просмотр',
      show: 'Показать',
      hide: 'Скрыть',
      more: 'Ещё',
      change: 'Изменить',
      confirm: 'Подтвердить',
      copy: 'Копировать',
      copied: 'Скопировано',

      completed: 'Завершено',
      inProgress: 'В процессе',
      notStarted: 'Не начато',
      locked: 'Закрыто',
      pending: 'На проверке',
      accepted: 'Принято',
      graded: 'Оценено',
      rejected: 'Возвращено',
      required: 'Обязательно',
      optional: 'Необязательно',

      course: 'Курс',
      courses: 'Курсы',
      module: 'Модуль',
      modules: 'Модули',
      lesson: 'Урок',
      lessons: 'Уроки',
      homework: 'Домашнее задание',
      video: 'Видео',
      file: 'Файл',
      files: 'Файлы',
      image: 'Изображение',
      points: 'Баллы',
      progress: 'Прогресс',
      grade: 'Оценка',
      comment: 'Комментарий',
      date: 'Дата',
      phone: 'Телефон',
      name: 'Имя',
      fullName: 'Имя и фамилия',
      username: 'Логин',
      password: 'Пароль',
      email: 'Электронная почта',
      lessonsCount: (v, lang) =>
        plural(lang, Number(v.n), { one: '{n} урок', few: '{n} урока', many: '{n} уроков', other: '{n} урока' }),
      lessonsDone: 'Пройдено уроков: {done} из {total}',
      pointsCount: (v, lang) =>
        plural(lang, Number(v.n), { one: '{n} балл', few: '{n} балла', many: '{n} баллов', other: '{n} балла' }),

      emptyTitle: 'Здесь пока ничего нет',
      noResults: 'Ничего не найдено',
      loadFailed: 'Не удалось загрузить',
      unnamed: 'Без имени',
      notSet: 'Не указано',
      durationHm: '{h} ч {m} мин',

      dropHint: 'Перетащите файл сюда или нажмите, чтобы выбрать',
      dropHintMany: 'Перетащите файлы сюда или нажмите, чтобы выбрать',
      dropRelease: 'Отпустите, чтобы добавить',
      wrongType: 'Файл «{name}» такого типа здесь не принимается.',

      phoneNumber: 'Номер телефона',
      phoneCountry: 'Узбекистан, +998',
      phoneIncomplete: 'Введите номер полностью: 9 цифр.',
    },
    de: {
      save: 'Speichern',
      saving: 'Wird gespeichert…',
      saved: 'Gespeichert',
      cancel: 'Abbrechen',
      close: 'Schließen',
      back: 'Zurück',
      next: 'Weiter',
      previous: 'Zurück',
      continue: 'Weitermachen',
      start: 'Starten',
      search: 'Suchen',
      loading: 'Wird geladen…',
      retry: 'Erneut versuchen',
      refresh: 'Aktualisieren',
      yes: 'Ja',
      no: 'Nein',
      all: 'Alle',
      none: 'Keine',
      download: 'Herunterladen',
      upload: 'Hochladen',
      uploading: 'Wird hochgeladen…',
      uploadingPercent: 'Wird hochgeladen… {percent} %',
      add: 'Hinzufügen',
      remove: 'Entfernen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      send: 'Senden',
      sending: 'Wird gesendet…',
      submit: 'Abgeben',
      done: 'Fertig',
      open: 'Öffnen',
      view: 'Ansehen',
      show: 'Anzeigen',
      hide: 'Ausblenden',
      more: 'Mehr',
      change: 'Ändern',
      confirm: 'Bestätigen',
      copy: 'Kopieren',
      copied: 'Kopiert',

      completed: 'Abgeschlossen',
      inProgress: 'In Bearbeitung',
      notStarted: 'Nicht begonnen',
      locked: 'Gesperrt',
      pending: 'Wird geprüft',
      accepted: 'Angenommen',
      graded: 'Bewertet',
      rejected: 'Zurückgegeben',
      required: 'Pflicht',
      optional: 'Optional',

      course: 'Kurs',
      courses: 'Kurse',
      module: 'Modul',
      modules: 'Module',
      lesson: 'Lektion',
      lessons: 'Lektionen',
      homework: 'Hausaufgabe',
      video: 'Video',
      file: 'Datei',
      files: 'Dateien',
      image: 'Bild',
      points: 'Punkte',
      progress: 'Fortschritt',
      grade: 'Note',
      comment: 'Kommentar',
      date: 'Datum',
      phone: 'Telefonnummer',
      name: 'Name',
      fullName: 'Vollständiger Name',
      username: 'Benutzername',
      password: 'Passwort',
      email: 'E-Mail',
      lessonsCount: (v, lang) => plural(lang, Number(v.n), { one: '{n} Lektion', other: '{n} Lektionen' }),
      lessonsDone: '{done} von {total} Lektionen abgeschlossen',
      pointsCount: (v, lang) => plural(lang, Number(v.n), { one: '{n} Punkt', other: '{n} Punkte' }),

      emptyTitle: 'Noch nichts vorhanden',
      noResults: 'Nichts gefunden',
      loadFailed: 'Konnte nicht geladen werden',
      unnamed: 'Ohne Namen',
      notSet: 'Nicht angegeben',
      durationHm: '{h} Std. {m} Min.',

      dropHint: 'Datei hierher ziehen oder zum Auswählen klicken',
      dropHintMany: 'Dateien hierher ziehen oder zum Auswählen klicken',
      dropRelease: 'Zum Hinzufügen loslassen',
      wrongType: '„{name}“: Dieser Dateityp wird hier nicht angenommen.',

      phoneNumber: 'Telefonnummer',
      phoneCountry: 'Usbekistan, +998',
      phoneIncomplete: 'Geben Sie die vollständige Nummer ein: 9 Ziffern.',
    },
  },
)
